export default {
	computed:{
		configuracion(){        
      return this.$store.state.AppData.data.configuracion;
    }
	}
}